import { render, staticRenderFns } from "./ContentPlaceholdersText.vue?vue&type=template&id=156052e1"
import script from "./ContentPlaceholdersText.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholdersText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports